export const environment = {
  production: false,
  serverUrl: '',
  clientId: '8b55d5e1-1ca5-4c6d-a345-70e6b32388a2',
  authority: 'https://login.microsoftonline.com/0ae51e19-07c8-4e4b-bb6d-648ee58410f4/',
  graphUrl: 'https://graph.microsoft.com/v1.0/me',
  apiScope: ['openid', 'profile', 'api://8b55d5e1-1ca5-4c6d-a345-70e6b32388a2/access_as_user'],
  graphApiScope: [ 'ProfilePhoto.Read.All']
};
